import styled from '@mui/system/styled';
import { Theme } from '@mui/material';

export const AdvisorsWrapper = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    marginTop: '2px',
    '@media (max-width: 320px) ': {
      paddingLeft: 0,
      paddingRight: 0
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '10px'
    }
  })
);

export const AdvisorCardSkeletonContainer = styled('div')({
  padding: '24px 0',
  borderTop: '1px solid #ebedf0'
});

export default AdvisorsWrapper;
